export default __webpack_public_path__ + "static/media/uncollapse.e284f3ab.svg";